{
  "Alerts": "Alerts",
  "Appointment List": "Appointment List",
  "Click to Call": "Click to Call",
  "Contact Patients": "Contact Patients",
  "Insurance": "Insurance",
  "No Appointments": "No Appointments",
  "No Appointments found": "No Appointments found",
  "Request Payment": "Request Payment",
  "Requests": "Requests",
  "Send Form": "Send Form",
  "Send Message": "Send Message",
  "Switch to analytics view": "Switch to analytics view",
  "Switch to patient list view": "Switch to patient list view",
  "Today": "Today",
  "Unknown": "Unknown",
  "{{count}} Patients_one": "{{count}} Patient",
  "{{count}} Patients_other": "{{count}} Patients"
}
